import { Typography } from '@mui/material'
import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import { DialogBooking } from 'src/views/booking'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import TableBooking from '../../views/booking/TableBooking'

const BookingList = () => {
    const [reload, setReload] = useState(0)
    const [bookingID, setBookingID] = useState(0)
    const [showBookingInfo, setBookingInfo] = useState(false)

    useEffect(() => {
        !showBookingInfo && setBookingID(0)
    }, [showBookingInfo])

    useEffect(() => {
        bookingID > 0 && setBookingInfo(true)
    }, [bookingID])

    return (
    <Page title="Category">
        <Grid container spacing={6}>
            <PageHeader
                title={
                    <Typography variant='h5' color='#666CFF'>
                        상품 입고알림
                    </Typography>
                }
                subtitle={
                    <Alert severity='info' sx={{mt:2}}>
                        고객이 요청한 상품 입고알림 회신은 상품 재고수량을 변경후, 통보날짜를 설정해야합니다.
                    </Alert>
                }
            />
            <DialogBooking show={showBookingInfo} setShow={setBookingInfo} setReload={setReload} bookingID={bookingID}/>
            <Grid item xs={12}>
                <TableBooking reload={reload} setReload={setReload} setBookingID={setBookingID}/>
            </Grid>
        </Grid>
    </Page>
    )
}

export default BookingList